export default {
      id: "x-circle-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#x-circle",
      toString: function () {
        return this.url;
      }
    }